import { Button, TextField, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ReviewsIcon from "@material-ui/icons/RateReview";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { getCustomers } from "../../../../api/customer";
import {
  deleteOfferHeader,
  getOfferHeaders,
} from "../../../../api/offerHeader";
import { getOfferStatus } from "../../../../api/offerStatus";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import FiltersCard from "../../../components/filters/Filter";
import Table, {
  buttonsStyle,
  getCurrentTablePage,
  offerStatusFormatter,
} from "../../../components/tables/table";
import OfferRevisionTableDialog from "../../../components/dialogs/OfferRevisionTableDialog";
import { OFFER_STATUS } from "../../../../utils/constants";

function getData(offerHeaders, customers, offerStatus) {
  let data = [];
  for (let i = 0; i < offerHeaders.length; ++i) {
    const elem = {};
    const offerHeader = offerHeaders[i];

    elem.estado = offerStatus?.find((x) => x.id === offerHeader?.estado_id);
    elem.numOferta = offerHeader?.num_oferta;
    elem.cliente = customers?.find(
      (x) => x.id === offerHeader?.cliente_id
    )?.nombre;
    elem.localizacion = offerHeader?.localizacion;
    elem.referencia = offerHeader?.referencia;
    elem.revisionNum = offerHeader?.revision_num;
    elem.id = i;

    elem.key = {
      id: offerHeader?.id,
      revisionNum: offerHeader?.revision_num,
      revisionNums: offerHeader?.revision_nums,
      offerStatus: elem?.estado,
    };

    data = data.concat(elem);
  }
  return data;
}

function agruparOfertas(ofertas) {
  let ofertasAgrupadas = [];
  let ofertasIdsAgrupadas = [];

  for (let oferta of ofertas) {
    let ofertaCopia = { ...oferta };

    if (!ofertasIdsAgrupadas.includes(ofertaCopia.id)) {
      ofertaCopia.revision_nums = false;
      ofertasAgrupadas.push(ofertaCopia);
      ofertasIdsAgrupadas.push(ofertaCopia.id);
    } else {
      const ofertaAgrupada = ofertasAgrupadas.find(
        (item) => item.id === ofertaCopia.id
      );
      if (ofertaAgrupada.revision_num < ofertaCopia.revision_num) {
        ofertaAgrupada.revision_num = ofertaCopia.revision_num;
        ofertaAgrupada.estado_id = ofertaCopia.estado_id;
      }
      ofertaAgrupada.revision_nums = true;
    }
  }

  return ofertasAgrupadas;
}

const initialFilters = {
  cliente: "",
};

export default function OffersPage() {
  const [data, setData] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);

  const [customers, setCustomers] = useState([]);
  const [offerStatus, setOfferStatus] = useState([]);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);

  const [revisionData, setRevisionData] = useState([]);
  const [
    openOfferRevisionTableDialog,
    setOpenOfferRevisionTableDialog,
  ] = useState(false);

  const history = useHistory();
  const location = useLocation();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  function buttonFormatter(key) {
    const offerId = key?.id;
    const revisionNum = key?.revisionNum;
    const revisionNums = key?.revisionNums;
    const offerStatus = key?.offerStatus;
    const elem = data.find(
      (item) => item.id === offerId && item.revision_num === revisionNum
    );
    return (
      <>
        {offerStatus?.id !== OFFER_STATUS.PRESENTADA && (
          <Tooltip title="Editar">
            <Button
              style={buttonsStyle}
              size="small"
              onClick={(e) => {
                history.push({
                  pathname: `/ofertas/${offerId}/${revisionNum}/edit`,
                  state: {
                    page: getCurrentTablePage(location),
                  },
                });
              }}
            >
              <EditIcon />
            </Button>
          </Tooltip>
        )}
        <Tooltip title="Eliminar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedOffer(elem);
              setOpenConfirmDialog(2);
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
        {revisionNums && (
          <Tooltip title="Revisiones Editables">
            <Button
              style={buttonsStyle}
              size="small"
              onClick={(e) => {
                setRevisionData(
                  data.filter(
                    (x) =>
                      x.id === offerId &&
                      x.estado_id !== OFFER_STATUS.PRESENTADA
                  )
                );
                setOpenOfferRevisionTableDialog(true);
              }}
            >
              <ReviewsIcon />
            </Button>
          </Tooltip>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "numOferta", text: "Número de oferta", sort: true },
    {
      dataField: "revisionNum",
      text: "Revisión",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "cliente",
      text: "Cliente",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "localizacion",
      text: "Localización",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "referencia",
      text: "Referencia de obra",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "estado",
      text: "Estado",
      sort: true,
      headerAlign: "center",
      align: "center",
      formatter: offerStatusFormatter,
    },
    { dataField: "key", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getCustomers(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setCustomers(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los clientes.",
        });
      });
    getOfferStatus(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setOfferStatus(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los estados.",
        });
      });
    getOfferHeaders(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(agruparOfertas(res.data));
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las ofertas.",
        });
      });
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.cliente)
          filter = filter && filterOptions?.cliente?.id === item?.cliente_id;

        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <>
        <div className="d-sm-flex w-100">
          <Autocomplete
            className="w-100 mr-5"
            id="autocomplete-customer"
            filterSelectedOptions
            options={customers}
            getOptionLabel={(option) => option?.nombre}
            value={filterOptions.cliente || ""}
            onChange={(event, selected) => {
              setFilterOptions({
                ...filterOptions,
                cliente: selected,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Cliente"
              />
            )}
          />
        </div>
      </>
    );
  };

  return (
    <>
      <Card>
        <CardHeader headerClassName="px-0">
          <CardHeader
            title="Ofertas"
            sticky={false}
            headerClassName="d-flex justify-content-between w-100 py-3"
          >
            <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() =>
                  history.push({
                    pathname: "/ofertas/edit",
                  })
                }
              >
                Nueva oferta
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <div className="w-100">
            <FiltersCard
              collapsable={false}
              filtersContent={renderFiltersContent}
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              handleClearFilters={handleClearFilters}
              handleSearch={handleSearch}
            />
          </div>
        </CardHeader>
        <CardBody>
          <Table
            data={getData(filteredData, customers, offerStatus)}
            columns={columns}
          />

          <ConfirmDialog
            title={"¿Estás seguro de que quieres eliminar esta oferta?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteOfferHeader(
                selectedOffer?.id,
                selectedOffer?.revision_num,
                loggedUser?.accessToken
              )
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "¡Eliminada!",
                      customMessage: "Oferta eliminada con éxito.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar la oferta.",
                  });
                });
            }}
          />
          <OfferRevisionTableDialog
            title={"Revisiones Editables"}
            open={openOfferRevisionTableDialog}
            setOpen={setOpenOfferRevisionTableDialog}
            data={revisionData}
            customers={customers}
            offerStatus={offerStatus}
          />
        </CardBody>
      </Card>
    </>
  );
}
